module.exports = __webpack_public_path__ + "static/media/selected_icn_map_event_car_panne.bcf067d7.svg";